import React from 'react';
import { observer } from 'mobx-react-lite';
import { ImagesGrid } from 'polotno/side-panel/images-grid';
import { getImageSize } from 'polotno/utils/image';

export const Images = observer(({ store, api, getCredit }) => {
  const [items, setItems] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);

  async function load() {
    setIsLoading(true);
    const req = await fetch(api);
    const json = await req.json();
    let images = json.images;
    if (!images && json.length) {
      // change case
      images = json.map(({ imageURL, productKey }) => ({
        imageUrl: imageURL,
        productKey,
      }));
    }
    setItems(images);
    setIsLoading(false);
  }
  React.useEffect(() => {
    load();
  }, [api]);

  return (
    <div style={{ height: '100%', overflow: 'auto' }}>
      <ImagesGrid
        images={items}
        getPreview={(item) => item.imageUrl}
        onSelect={async (item, pos, element) => {
          if (element) {
            element.set({
              src: item.imageUrl,
              cropX: 0,
              cropY: 0,
              cropWidth: 1,
              cropHeight: 1,
            });
            return;
          }
          const { width, height } = await getImageSize(item.imageUrl);

          const scaleX = store.width / width / 2;
          const scaleY = store.height / height / 2;
          const scale = Math.min(scaleX, scaleY, 1);
          store.activePage.addElement({
            type: 'image',
            src: item.imageUrl,
            width: width * scale,
            height: height * scale,
            x: pos ? pos.x - (width * scale) / 2 : 0,
            y: pos ? pos.y - (height * scale) / 2 : 0,
          });
        }}
        rowsNumber={2}
        isLoading={isLoading}
        loadMore={false}
        getCredit={getCredit}
      />
    </div>
  );
});
